import '@popperjs/core';

try {

    /**
     * Get Bootstrap
     */
    window.bootstrap = require('bootstrap');

} catch (e) {

}
